export const FETCH_DATA = 'INSURANCE:FETCH_DATA';
export const FETCH_DATA_SUCCESS = 'INSURANCE:FETCH_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'INSURANCE:FETCH_DATA_ERROR';
